//#region src/services/IFileStoreServicePublic.ts
const FILE_STORE_SERVICE_PUBLIC_IDENT = "org.aimystic.service.FileStoreServicePublic";
const RPC_EVENT_FILE_ADDED_IDENT = "org.aimystic.event.fileAdded";
const RPC_EVENT_FILE_UPDATED_IDENT = "org.aimystic.event.fileUpdated";
const RPC_EVENT_FILE_DELETED_IDENT = "org.aimystic.event.fileDeleted";
const RPC_EVENT_FILE_ADDED = {
	ident: RPC_EVENT_FILE_ADDED_IDENT,
	description: "Event emitted when a file is added",
	params: [{
		name: "fileEntry",
		type: "object",
		description: "The added file entry"
	}],
	groups: ["workspace"]
};
const RPC_EVENT_FILE_UPDATED = {
	ident: RPC_EVENT_FILE_UPDATED_IDENT,
	description: "Event emitted when a file is updated",
	params: [{
		name: "fileEntry",
		type: "object",
		description: "The updated file entry"
	}],
	groups: ["workspace"]
};
const RPC_EVENT_FILE_DELETED = {
	ident: RPC_EVENT_FILE_DELETED_IDENT,
	description: "Event emitted when a file is deleted",
	params: [{
		name: "fileId",
		type: "string",
		description: "The deleted file ID"
	}, {
		name: "workspaceId",
		type: "string",
		description: "The workspace ID (if applicable)"
	}],
	groups: ["workspace"]
};

//#endregion
export { FILE_STORE_SERVICE_PUBLIC_IDENT, RPC_EVENT_FILE_ADDED, RPC_EVENT_FILE_ADDED_IDENT, RPC_EVENT_FILE_DELETED, RPC_EVENT_FILE_DELETED_IDENT, RPC_EVENT_FILE_UPDATED, RPC_EVENT_FILE_UPDATED_IDENT };
//# sourceMappingURL=IFileStoreServicePublic.js.map